<template>
  <div>
    <p class="pb-1">
      Pogodba
      <strong>{{ data.pogodba.ID }}</strong
      >, veljavna do <strong>{{ data.pogodba.Datum_konec }}</strong
      >, VIN
      <a
        :href="`https://avtolog.si/search/${data.pogodba.Sasija}`"
        target="_avtolog"
      >
        <strong>{{ data.pogodba.Sasija }}</strong>
      </a>
      <span v-show="pogodba_je_potekla" class="red white--text ml-2 pa-2"
        >POGODBA JE POTEKLA!</span
      >
    </p>
    <p>
      <span v-show="prostoZaIzplacilo >= 0" class="green white--text pa-2">
        Prosto izplačilo
        <strong
          >{{ eur(prostoZaIzplacilo) }} /
          {{ eur(prostoZaIzplaciloSPopustom) }}</strong
        >
      </span>
      <span v-show="prostoZaIzplacilo < 0" class="red white--text pa-2">
        Prekomerno izplačilo
        <strong
          >{{ eur(prostoZaIzplacilo) }} /
          {{ eur(prostoZaIzplaciloSPopustom) }}</strong
        >
      </span>
      <span v-if="data.produkt" class="ml-4"
        >Maksimalno izplačilo za produkt {{ data.produkt.Naziv }} je
        {{ eur(data.produkt.MaxIzplacilo) }}</span
      >
    </p>

    <div class="pogodba-grid pb-5">
      <div>Agent</div>
      <div>Produkt</div>
      <div>Stranka</div>
      <div>Vozilo</div>
      <strong>{{ data.pogodba.Agent_ID }}</strong>
      <strong>{{ data.pogodba.Produkt_naziv }}</strong>
      <strong>{{ data.pogodba.Ime_Priimek }}</strong>
      <strong>{{ data.pogodba.NazivVozila }}</strong>
    </div>

    <div class="pogodba-grid pb-5">
      <div>Stanje km</div>
      <div>Komentar</div>
      <div>Opomba</div>
      <div>Opomba 2</div>
      <strong>{{ data.pogodba.Stanje_km }}</strong>
      <strong>{{ data.pogodba.Komentar }}</strong>
      <strong>{{ data.pogodba.Homologacija }}</strong>
      <strong>{{ data.pogodba.Opomba_2 }}</strong>
    </div>

    <div class="prejsnje-skode header">
      <div>Pogodba</div>
      <div>ZŠ</div>
      <div>Status</div>
      <div>Datum</div>
      <div>Opis</div>
      <div class="text-right">Izplačilo</div>
    </div>
    <v-divider></v-divider>

    <div v-for="item in data.skode" :key="item.ID">
      <div class="prejsnje-skode table">
        <div>
          {{ item.Pogodba_ID }}
          <br />
          <a :href="`/skode/${item.ID}/uredi`">{{ item.ID }}</a>
        </div>
        <div>
          <a
            :href="
              'https://www.garancija-gsv.com/skode/prijave/index.php?PME_sys_operation=PME_op_View&PME_sys_rec=' +
              item.ID
            "
            target="view_record"
            >#{{ item.ZS }}</a
          >
        </div>
        <div>{{ item.Status }}</div>
        <div>
          {{ new Date(item.Datum_SQL).toLocaleDateString("sl-SI") }}
        </div>
        <div>
          {{ item.Opis_skode }}<br />
          <b>{{ item.Delavnica }}</b> <br />
          <div v-if="item.Opomba">
            <span class="font-weight-bold">{{ item.Opomba }}</span>
          </div>
        </div>

        <div>
          <div class="text-right">
            <strong v-show="item.Znesek_izplacilo != 0">
              <br />
              {{ eur(item.Znesek_izplacilo) }} /
              {{ eur(item.Skupaj_s_popustom) }}
            </strong>
          </div>
        </div>
      </div>
      <StroskiSkode
        :skoda="item"
        :edit="parseInt(skoda_id) === parseInt(item.ID)"
      />
      <!-- edit samo za izbrano skodo -->

      <v-divider class="mt-4"></v-divider>
    </div>
    <div class="mt-8">
      <div
        v-for="izplacilo in izplacilaPoPogodbi"
        :key="izplacilo.key"
        class="sume-grid"
      >
        <div></div>
        <div>
          Izplačilo po pogodbi
          <strong>{{ izplacilo.key }}</strong>
        </div>
        <div class="text-right">
          <strong
            >{{ eur(izplacilo.amount) }} /
            {{ eur(izplacilo.amount_s_popustom) }}</strong
          >
        </div>
      </div>
      <div class="sume-grid">
        <div></div>
        <div class="border-top">Skupaj izplačila</div>
        <div class="text-right border-top">
          <strong
            >{{ eur(sumaVsehIzplacil) }} / {{ eur(sumaVsehIzplacilSPopustom) }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StroskiSkode from "./StroskiSkode";
export default {
  props: ["data", "skoda_id"],
  // data so podatki o pogodi, skoda_id je trenutna skoda, da lahko dovolimo vnose na delnovni nalog zanjo
  components: {
    StroskiSkode,
  },

  computed: {
    pogodba_je_potekla() {
      var d1 = new Date();
      var d2 = new Date(this.data.pogodba.Datum_konec_SQL);
      var ret = d1 > d2;
      return ret;
    },

    izplacilaPoPogodbi() {
      var sume = [];
      let that = this;

      this.data.skode.forEach((element) => {
        let k = element.Pogodba_ID; // key
        let o = sume.find((el) => el.key === k);
        if (!o)
          sume.push({
            key: element.Pogodba_ID,
            amount: 0,
            amount_s_popustom: 0,
          });
        let e = sume.find((el) => el.key === k);

        console.log("element", element);

        e.amount += parseFloat(element.Znesek_izplacilo);
        e.amount_s_popustom += parseFloat(element.Skupaj_s_popustom);

        console.log("e", e);
      });

      return sume;
    },

    sumaVsehIzplacil() {
      var ret = 0;
      this.izplacilaPoPogodbi.forEach((el) => {
        ret += parseFloat(el.amount);
      });
      return ret;
    },

    sumaVsehIzplacilSPopustom() {
      var ret = 0;
      this.izplacilaPoPogodbi.forEach((el) => {
        ret += parseFloat(el.amount_s_popustom);
      });
      return ret;
    },

    sumaTaPogodba() {
      var ret = 0;
      let that = this;
      this.izplacilaPoPogodbi.forEach((el) => {
        if (el.key == that.data.pogodba.ID) ret += parseFloat(el.amount);
      });
      return ret;
    },

    sumaTaPogodbaSPopustom() {
      var ret = 0;
      let that = this;
      this.izplacilaPoPogodbi.forEach((el) => {
        if (el.key == that.data.pogodba.ID)
          ret += parseFloat(el.amount_s_popustom);
      });
      return ret;
    },

    prostoZaIzplacilo() {
      var ret = 0;
      if (this.data.produkt) {
        ret = this.data.produkt.MaxIzplacilo - this.sumaTaPogodba;
      }
      return ret;
    },

    prostoZaIzplaciloSPopustom() {
      var ret = 0;
      if (this.data.produkt) {
        ret = this.data.produkt.MaxIzplacilo - this.sumaTaPogodbaSPopustom;
      }
      return ret;
    },
  },
};
</script>

<style scoped lang="scss">
.prejsnje-skode {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr 4fr 3fr;
  grid-gap: 2px;
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .prejsnje-skode {
    grid-template-columns: 2fr 1fr 1fr 2fr 8fr 3fr;
    grid-gap: 6px;
  }
}

.pogodba-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 2fr;
}

.border-top {
  border-top: 1px solid lightgray;
}

.sume-grid {
  display: grid;
  grid-template-columns: 2fr 3fr 1fr;
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .sume-grid {
    grid-template-columns: 4fr 3fr 2fr;
  }
}
</style>
